import { Component, Input, OnInit } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { ScheduledEvent } from '../../../../../../../../../../../models/scheduled-event';
import { CallbackResult, CallbackResultStatus, dateStringFromISO8601 } from '../../../../../../../../../../../utils';
import { Customer, CustomerFilters } from '../../../../../../../../../../../models/customer';
import { ListResponse } from '../../../../../../../../../../../models/list-response';
import { CustomerService } from '../../../../../../../../../../../services/customer/customer.service';
import { OrganizationConfigService } from '../../../../../../../../../../../services/organization-config/organization-config.service';
import { AccountService } from '../../../../../../../../../../../services/account/account.service';
import { ScheduledEventService } from '../../../../../../../../../../../services/scheduled-event/scheduled-event.service';
import { openClimberAppInNewTabAsCustomer, openClimberAppInNewTabAsStaff } from '../../../../../../../../../../../utils-models';
import { EventNote } from '../../../../../../../../../../../models/event';
import { EventService } from '../../../../../../../../../../../services/event/event.service';


@Component({
  selector: 'app-add-to-event-waitlist-modal',
  templateUrl: './add-event-note-modal.component.html',
  styleUrls: ['./add-event-note-modal.component.css']
})
export class AddEventNoteModalComponent implements OnInit {

  @Input() scheduledEvent: ScheduledEvent;
  @Input() addedCallback: (result: CallbackResult) => undefined;

  public note: EventNote = {
    id: 0,
    url: '',
    event_id: 0,
    title: '',
    text: '',
    created_by_id: 0,
    created_by_first_name: '',
    created_by_last_name: '',
    last_updated_by_id: 0,
    last_updated_by_first_name: '',
    last_updated_by_last_name: '',
    created_at: '',
    updated_at: ''
  }

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    private eventService: EventService
  ) {}

  ngOnInit() {
    this.note.event_id = this.scheduledEvent.event_id;
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';
    this.errors = {};

    this.eventService
      .addEventNote(this.note)
      .then(createdNote => {
        this.addedCallback({
          text: 'Note created successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to create notes.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
